import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'scoring-legend-dialog',
    templateUrl: './scoring-legend-dialog.component.html',
    styleUrls: ['./scoring-legend-dialog.component.css'],
    imports: [CommonModule, MaterialModule]
})
export class ScoringLegendDialogComponent {
    constructor(public dialogRef: MatDialogRef<ScoringLegendDialogComponent>) {}

    onClose(): void {
        this.dialogRef.close();
    }
}
